define([
    'jquery',
    'core/urls',
    'components/datatable',
    'core/intercom',
    'core/browser-storage',
    ],
    function(
        $, 
        urls, 
        datatable, 
        intercom,
        browser_storage) {

        let nodes = {
            canvas: document.querySelector(".canvas"),
            page: document.querySelector(".csat-live-dashboard"),
            settingsToggle: document.querySelector(".settings-toggle-wrap"),
            settingsPanel: {
                parent: document.querySelector(".settings-panel"),
                fieldTogglesWrapper: document.querySelector(".settings-panel .fields .toggles"),
                fieldToggles: document.querySelectorAll(".mini-toggle.field input"),
                settingsError: document.querySelector(".settings-error"),
                saveButton: document.querySelector(".settings-panel .save-changes"),
                autoScrollToggle: document.querySelector(".settings-panel #autoScrollToggle"),
                showStatusToggle: document.querySelector(".settings-panel #statusToggle"),
                showPublishedToggle: document.querySelector(".settings-panel #publishedToggle"),
                fontSelectors: document.querySelectorAll(".settings-panel .font-options div"),
                sentimentSelectors: document.querySelectorAll(".settings-panel .sentiment-options div")
            },
            miniLogo: document.querySelector(".mini-logo"),
            fullScreenToggle:  document.querySelector(".full-screen-toggle"),
            fullScreenLabel:  document.querySelector(".full-screen-toggle .label"),
        }

        let tssType = document.querySelector(".csat-live-dashboard").dataset.platform; 

        // this array contains a list of all available data fields
        let availableFields = JSON.parse(document.querySelector("#reviewFields").innerText);
        let availableFieldIDs = {};
        
        availableFields.forEach(field => {
            if(field.visible) {
                availableFieldIDs[field.id] = field.display_name;
            }
        });

        // this array keeps track of user saved settings (which fields to display)
        let fieldsToRender = ["sentiment", "timestamp", "ticket", "company", "contact", "agents", "segment", "comment"];
        let sentimentsToRender = ["1", "0", "-1"]; // positive, neutral, negative
        let commentRows = [];
        let enableComments = true;
        let autoScroll = true;
        let scrollDelay;
        let timerReset;
        let initialRendering = true;
        let currentData = null;

        let storedFieldsToRender = JSON.parse(browser_storage.getItem("reviews-stream-fields"));
        let storedSentiments = JSON.parse(browser_storage.getItem("reviews-stream-sentiments"));
        
        if(storedFieldsToRender) {
            fieldsToRender = storedFieldsToRender;
        } else {
            browser_storage.setItem("reviews-stream-fields", JSON.stringify(fieldsToRender));
        }

        if(storedSentiments) {
            sentimentsToRender = storedSentiments;
        } else {
            browser_storage.setItem("reviews-stream-sentiments", JSON.stringify(sentimentsToRender));
        }

        let generateSentimentClass = (sentimentValue) => {
            if (sentimentValue == 1) {
                return 'positive';
            } else if (sentimentValue == 0) {
                return 'neutral';
            } else if (sentimentValue == -1) {
                return 'negative';
            }
        }

        let renderComment = (rowData, allRows) => {
            
            let currentRow = allRows[rowData.index];
            currentRow.classList.add("has-comment");

            let sentimentClass = generateSentimentClass(rowData.data.sentiment);

            let commentRow = document.createElement("tr");
            let publishedTag = '';
            
            if (rowData.data.widget_publicize && browser_storage.getItem("reviews-stream-show-published") === "true") {
                publishedTag = '<span class="published">Published</span>';
            }

            let comment = `
                <td colspan="${fieldsToRender.length - 1}">
                    <div class="csat-reaction-child csat-reaction-type-${sentimentClass}">
                        <div class="csat-reaction-child-comment">
                            <p>${rowData.data.comment}</p>
                            ${publishedTag}
                        </div>                        
                    </div>
                </td>`;

            commentRow.innerHTML = comment;
        
            currentRow.parentNode.insertBefore(commentRow, currentRow.nextSibling);
        }
        
        let createDatatable = () => {   
            let columns = [];
            commentRows = [];
            enableComments =  false;

            let queryString = '';

            if (sentimentsToRender.length < 3) {
                sentimentsToRender.forEach((sentiment, i) => {
                    let separator = i === 0 ? '?' : '&';
                    queryString += `${separator}sentiment=${sentiment}`;
                })
            }

            fieldsToRender.forEach((field) => {
                if(field === "sentiment" && availableFieldIDs["sentiment"]) {
                    columns.push({
                        title: availableFieldIDs["sentiment"],
                        width: "48px",
                        className: "column-sentiment",
                        data: "sentiment",
                        render: {
                            _: function (data) {                                
                                return `
                                    <div class="image-wrapper">
                                        <img src="${globals.getSentimentImageUrl(data)}" alt="${globals.getSentimentLabel(data)}" height="30" width="30">
                                    </div>`;
                            }
                        }
                    })
                }

                if(field === "timestamp" && availableFieldIDs["timestamp"]) {
                    columns.push({
                        title: availableFieldIDs["timestamp"],
                        width: "100px",
                        className: "column-date",
                        data: "timestamp",
                        render: {
                            _: "formatted",
                            sort: "iso8601",
                            exportPrint: "formatted",
                            exportTabular: function (data) {
                                return moment(data.iso8601).format('YYYY-MM-DD HH:mm:ss');
                            }
                        }
                    })
                }

                if(field === "ticket" && availableFieldIDs["ticket"]) {
                    columns.push({
                        title: availableFieldIDs["ticket"],
                        width: "20%",
                        className: "column-ticket",
                        data: "ticket",
                        render: {
                            _: "id",
                            display: function(data) {
                                if(tssType === 'sc') {
                                    return data.link != null ? `<a target="_blank" href="${data.link}">${data.title}</a>` : `${data.title}`;
                                }
                                return data.link != null ? `<a target="_blank" href="${data.link}">${data.id}</a><br>${data.title}` : `${data.id}<br>${data.title}`;
                            },
                        }
                    })
                }

                if(field === "company" && availableFieldIDs["company"]) {
                    columns.push({
                        title: availableFieldIDs["company"],
                        width: "100px",
                        className: "column-company",
                        data: "company",
                        render: {
                            _: "name",
                            display: function (data) {
                                return (data.link !== null && data.link !== '') ? '<a target="_blank" href="' + data.link + '">' + data.name + '</a>' : data.name;
                            }
                        }
                    })
                }

                if(field === "contact" && availableFieldIDs["contact"]) {
                    columns.push({
                        title: availableFieldIDs["contact"],
                        width: "90px",
                        className: "column-contact",
                        data: "contact",
                        render: {
                            _: "name",
                            display: function (data) {
                                return data.link != null ? '<a target="_blank" href="' + data.link + '">' + data.name + '</a>' : data.name;
                            }
                        }
                    })
                }

                if(field === "agents" && availableFieldIDs["agents"]) {
                    columns.push({
                        title: availableFieldIDs["agents"],
                        width: "90px",
                        className: "column-resources",
                        data: "agents"
                    })
                }

                if(field === "segment" && availableFieldIDs["segment"]) {
                    columns.push({
                        title: availableFieldIDs["segment"],
                        width: "69px",
                        className: "column-board",
                        data: "segment"
                    })
                }

                if(field === "comment") {
                    enableComments = true;
                }
            })

            window.reactions = datatable.create('#reactions', {
                columns,
                order: [[0, 'desc']],
                ajax: {
                    url: urls['csat:review-data-top']()+queryString,
                    dataSrc: "reactions",
                    global: false,
                    headers: {
                        'Call-Version': '3'
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        if (jqXHR.status == 302) {
                            // server requested a page reload
                            window.location.reload();
                        } else if(jqXHR.status == 403) {
                             window.location.href = urls['account:auth-login']() + '?next=' + window.location.pathname;
                        } else {
                            $('.dataTables_empty').text('Error loading data. Auto-retrying in less than 5 minutes...');
                        }
                    }
                },
                initComplete: (settings, data) => {

                    let allRows = document.querySelectorAll("#reactions tbody tr");
                    let table = document.querySelector("#reactions");

                    let previousData = currentData;
                    currentData = data;

                    if(previousData && previousData.reactions.length > 0) {
                        let topPreviousTimestamp = previousData.reactions[0].timestamp.iso8601;
                        let topCurrentTimestamp = currentData.reactions[0].timestamp.iso8601;

                        if(topPreviousTimestamp !== topCurrentTimestamp) {
                            for (let i = 0; i < currentData.reactions.length; i++) {
                                if(topPreviousTimestamp >= currentData.reactions[i].timestamp.iso8601) {
                                    break;
                                }
                                
                                allRows[i].classList.add("highlight");
                            }
                        }
                    } 
                    
                    table.dataset.font = browser_storage.getItem("reviews-stream-font-size");

                    if(enableComments) {
                        commentRows.forEach(rowData => {
                            renderComment(rowData, allRows);
                        })
                    }

                    if(autoScroll && !initialRendering) {
                        clearInterval(scrollDelay);
                        setTimeout(initAutoScroll, 3000);                        
                    }

                    initialRendering = false;
                    if (nodes.settingsPanel.saveButton.classList.contains("loading")) {
                        nodes.settingsPanel.saveButton.classList.remove("loading");
                        nodes.settingsPanel.saveButton.classList.add("loaded");
                        nodes.settingsPanel.parent.classList.add("hide");
                        nodes.settingsToggle.classList.remove("active");
                        setTimeout(() => {
                            nodes.settingsPanel.saveButton.classList.remove("loaded");
                        }, 2000)
                    }
                },
                createdRow: (row, data, index) => {
                    row.setAttribute("role", "row");
                    row.classList.add(generateSentimentClass(data.sentiment));
                    
                    if(data.status === "done" && browser_storage.getItem("reviews-stream-show-status") === "true") {
                        row.classList.add("status-done")
                    }

                    if(data.comment.length) {
                        commentRows.push({row, data, index});
                    }
                },
                pageLength: 25,
                ordering: false,   // we're only loading the first 25 records anyway, so ordering would give a completely wrong picture, because it would take 99% of the data not into account
                dom: 't',
                buttons: [],
                stateSave: false
            });
        }

        let renderFieldToggles = () => {
            let renderedToggles = '';

            availableFields.forEach(field => {
                if(field.visible && field.id !== "comments") {
                    renderedToggles += `
                        <div class="mini-toggle field">
                            <input type="checkbox" id="${field.id}Toggle" class="${field.id}" data-property="${field.id}">
                            <label for="${field.id}Toggle">
                                <div class="status">${field.display_name}</div>
                            </label>
                            <div class="description">${field.display_name}</div>
                        </div>
                    `
                }
            })

            nodes.settingsPanel.fieldTogglesWrapper.innerHTML = renderedToggles;
        }

        let updateToggles = () => {
            renderFieldToggles();

            let savedToggles = JSON.parse(browser_storage.getItem("reviews-stream-fields"));
            let autoScrollSetting = browser_storage.getItem("reviews-stream-autoscroll");
            let statusSetting = browser_storage.getItem("reviews-stream-show-status");
            let publishSetting = browser_storage.getItem("reviews-stream-show-published");

            savedToggles.forEach(toggleName => {
                let element = document.querySelector(`.mini-toggle input[data-property=${toggleName}]`);
                if(element) {
                    element.checked = true;
                }
            })

            if(autoScrollSetting === "false") {
                autoScroll = false;
                nodes.settingsPanel.autoScrollToggle.checked = false;
            }

            if(statusSetting === "true") {
                nodes.settingsPanel.showStatusToggle.checked = true;
            }

            if(publishSetting === "true") {
                nodes.settingsPanel.showPublishedToggle.checked = true;
            }

            if(document.querySelector('.mini-toggle input[data-property=comment]').checked) {
                nodes.settingsPanel.showPublishedToggle.parentElement.classList.remove("disabled")
            }

            let savedFontSize = browser_storage.getItem("reviews-stream-font-size");

            if (savedFontSize) {
                removeSelected(nodes.settingsPanel.fontSelectors);
                document.querySelector(`.font-options .${savedFontSize}`).classList.add("selected")
            }

            nodes.settingsPanel.sentimentSelectors.forEach(selector => {
                if(sentimentsToRender.indexOf(selector.dataset.type) === -1) {
                    selector.classList.remove("selected");
                } else {
                    selector.classList.add("selected");
                }
            })
            
        }

        let initAutoScroll = () => {
            let scrollableArea = document.querySelector(".csat-live-dashboard");
            let header = scrollableArea.querySelector("header");
            let tableHeader = scrollableArea.querySelector("#reactions thead");
            let tableBody = scrollableArea.querySelector("table tbody");
            let tableRows = scrollableArea.querySelectorAll("table tbody tr");
            let rowsHeight = 0;
            let scrollHeight = scrollableArea.offsetHeight - header.offsetHeight - tableHeader.offsetHeight;
            let firstRepeatedRow;

            scrollableArea.scrollTop = 0;

            for (let index = 0; index < tableRows.length; index++) {

                let currentRow = tableRows[index].cloneNode(true);                
                currentRow.classList.add("scroll-repeat");

                if(index === 0) {
                    currentRow.classList.add("first");
                    firstRepeatedRow = currentRow;
                }

                tableBody.appendChild(currentRow);
                rowsHeight += tableRows[index].offsetHeight;
                
                if (rowsHeight > scrollHeight) {
                    break;
                }
            }
            
            let tableBodyTopPosition = tableBody.getBoundingClientRect().top;

            scrollAmount = () => {
                // reset to the start of the loop if the repeated row reaches the top
                if((firstRepeatedRow.getBoundingClientRect().top) <= tableBodyTopPosition) {
                    scrollableArea.scrollTop = 0;
                }
                scrollableArea.scrollBy(0, 1);
            }

            // reset everything
            clearTimeout(timerReset)
            clearInterval(scrollDelay);
            scrollDelay = setInterval(scrollAmount, 50);
            
            addEventListener("wheel", (event) => {
                // event.preventDefault();
                clearInterval(scrollDelay);
                clearTimeout(timerReset)

                timerReset = setTimeout(() => {
                    scrollDelay = setInterval(scrollAmount, 50);
                }, 1000)
            }, {passive:false});
        }

        let removeSelected = (nodeGroup) => {
            nodeGroup.forEach(element => {
                element.classList.remove("selected");
            });
        }

        let createEventListeners = () => {
            let fullScreenToggleTimeout;

            nodes.settingsToggle.addEventListener("click", (event) => {
                event.currentTarget.classList.contains("active") ? event.currentTarget.classList.remove("active") : event.currentTarget.classList.add("active");
                nodes.settingsPanel.parent.classList.contains("hide") ? nodes.settingsPanel.parent.classList.remove("hide") : nodes.settingsPanel.parent.classList.add("hide");
            })

            nodes.fullScreenToggle.addEventListener("click", (event) => {
                if(event.currentTarget.classList.contains("active")) {
                    nodes.fullScreenToggle.classList.remove("active");
                    nodes.canvas.classList.remove("full-screen");
                    nodes.miniLogo.classList.add("hide");

                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.mozCancelFullScreen) { /* Firefox */
                        document.mozCancelFullScreen();
                    } else if (document.webkitExitFullscreen) { /* Safari */
                        document.webkitExitFullscreen();
                    } else if (document.msExitFullscreen) { /* IE11 */
                        document.msExitFullscreen();
                    }

                    nodes.fullScreenToggle.classList.remove("invisible");
                    clearTimeout(fullScreenToggleTimeout);
                } else {
                    nodes.canvas.classList.add("full-screen");
                    nodes.miniLogo.classList.remove("hide");
                    nodes.fullScreenToggle.classList.add("active");
                    nodes.settingsToggle.classList.remove("active");
                    nodes.settingsPanel.parent.classList.add("hide");

                    if (document.documentElement.requestFullscreen) {
                        document.documentElement.requestFullscreen();
                    } else if (document.documentElement.webkitRequestFullscreen) { /* Safari */
                        document.documentElement.webkitRequestFullscreen();
                    } else if (document.documentElement.msRequestFullscreen) { /* IE11 */
                        document.documentElement.msRequestFullscreen();
                    }
                }  
            })

            document.querySelector('.mini-toggle input[data-property=comment]').addEventListener("change", event => {
                if(event.target.checked) {
                    nodes.settingsPanel.showPublishedToggle.parentElement.classList.remove("disabled");
                } else {
                    nodes.settingsPanel.showPublishedToggle.parentElement.classList.add("disabled");
                }
                
            })
            
            const prefixes = ["", "moz", "webkit", "ms"]

            prefixes.forEach(prefix => {
                document.addEventListener(prefix + "fullscreenchange", () => {
                    let fullscreenElement = document.fullscreenElement || /* Standard syntax */
                    document.webkitFullscreenElement || /* Chrome, Safari and Opera syntax */
                    document.mozFullScreenElement || /* Firefox syntax */
                    document.msFullscreenElement /* IE/Edge syntax */;

                    if (fullscreenElement) {
                        nodes.settingsToggle.classList.add("hide");
                        nodes.fullScreenLabel.innerText = "Exit full screen";
                        nodes.fullScreenToggle.classList.add("active");
                        nodes.page.classList.add("full-screen");
    
                        setTimeout(() => {
                            if (document.fullscreenElement ||
                                document.webkitFullscreenElement ||
                                document.mozFullScreenElement || 
                                document.msFullscreenElement) {
                                nodes.fullScreenToggle.classList.add("invisible")
                            }
                        }, 4000)
    
                        if(autoScroll) {
                            clearInterval(scrollDelay);
                            setTimeout(initAutoScroll, 3000);                       
                        }
    
                    } else {
                        nodes.settingsToggle.classList.remove("hide");
                        nodes.fullScreenLabel.innerText = "Full screen";
                        nodes.fullScreenToggle.classList.remove("invisible");
                        nodes.fullScreenToggle.classList.remove("active");
                        nodes.page.classList.remove("full-screen");
                        clearTimeout(fullScreenToggleTimeout);
                        clearInterval(scrollDelay);
                    }
                });
            });
            

            addEventListener("mousemove", (event) => {
                if (document.fullscreenElement || /* Standard syntax */
                    document.webkitFullscreenElement || /* Chrome, Safari and Opera syntax */
                    document.mozFullScreenElement || /* Firefox syntax */
                    document.msFullscreenElement) 
                {
                    nodes.fullScreenToggle.classList.remove("invisible");

                    clearTimeout(fullScreenToggleTimeout);

                    fullScreenToggleTimeout = setTimeout(() => {
                        nodes.fullScreenToggle.classList.add("invisible")
                    }, 4000)
                }
            });

            nodes.settingsPanel.fontSelectors.forEach(selector => {
                selector.addEventListener("click", () => {
                    removeSelected(nodes.settingsPanel.fontSelectors);
                    selector.classList.add('selected');
                })
            })

            nodes.settingsPanel.sentimentSelectors.forEach(selector => {
                selector.addEventListener("click", () => {
                    if(selector.classList.contains("selected")) {
                        selector.classList.remove('selected');
                        sentimentsToRender = sentimentsToRender.filter(item => item !== selector.dataset.type);
                    } else {
                        selector.classList.add('selected');
                        sentimentsToRender.push(selector.dataset.type);
                    }
                })
            })

            nodes.settingsPanel.saveButton.addEventListener("click", () => {
                let toggledFields = [];
                let autoScrollValue = nodes.settingsPanel.autoScrollToggle.checked;
                let showStatusValue = nodes.settingsPanel.showStatusToggle.checked;
                let showPublishedValue = nodes.settingsPanel.showPublishedToggle.checked;
                let fontSize = document.querySelector(".font-options .selected").dataset.size;
                
                nodes.settingsPanel.settingsError.classList.add("hide");

                document.querySelectorAll(".mini-toggle.field input").forEach(toggle => {
                    if(toggle.checked) {
                        let name = toggle.dataset.property;
                        toggledFields.push(name);
                    }
                })

                if (!toggledFields.length || (toggledFields.length === 1 && toggledFields[0] === "comment")) {
                    nodes.settingsPanel.settingsError.innerText = "Please choose at least one field to display"
                    nodes.settingsPanel.settingsError.classList.remove("hide");
                    return;
                }

                if (!sentimentsToRender.length) {
                    nodes.settingsPanel.settingsError.innerText = "Please choose at least one review type to include"
                    nodes.settingsPanel.settingsError.classList.remove("hide");
                    return;
                }

                if (autoScrollValue) {
                    browser_storage.setItem("reviews-stream-autoscroll", "true");
                    autoScroll = true;
                    initAutoScroll();                    
                } else {
                    browser_storage.setItem("reviews-stream-autoscroll", "false");
                    autoScroll = false;
                    clearInterval(scrollDelay)
                }

                browser_storage.setItem("reviews-stream-show-status", showStatusValue);
                browser_storage.setItem("reviews-stream-show-published", showPublishedValue);

                browser_storage.setItem("reviews-stream-fields", JSON.stringify(toggledFields));
                browser_storage.setItem("reviews-stream-font-size", fontSize);

                browser_storage.setItem("reviews-stream-sentiments", JSON.stringify(sentimentsToRender));

                nodes.settingsPanel.saveButton.classList.add("loading");

                window.reactions.destroy();
                document.querySelector("#reactions").innerHTML = "";

                fieldsToRender = toggledFields;
                createDatatable();
            })
        }

        return {
            init: function() {
                updateToggles();
                createDatatable();
                createEventListeners();

                // track the event in Intercom
                intercom.trackEvent('opened-dashboard');

                // reload table every 5min
                setInterval(() => {
                    window.reactions.destroy();
                    document.querySelector("#reactions").innerHTML = "";
                    createDatatable();
                }, globals.settings.REVIEW_STREAM_RELOAD_INTERVAL*1000);
            }
        };
    }
);
